import React, { useEffect, useState } from 'react'
import { IFormInnerState } from '../form/IFormInnerState'
import { useAppBar } from '../../../components/appBar/appBarContext';
import { IGetFormRejectReasonsRequest, IGetFormRejectReasonsResponse } from '../../../models/registration.model';
import { useDispatch } from 'react-redux';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import DynamicActionForm from '../../../components/dynamicForm/dynamicForm';
import { Typography } from '@mui/material';
import CustomisedButton from '../../../components/button/button';
import { log } from 'console';
import { useMutation } from 'react-query';
import { GetAdditionalFields, SetAdditionalFields } from '../../../services/additionalFields.service';
import { IFields, IAdditionalFieldsRsponse, SetAdditionalFieldsResponse } from '../../../models/additionalFeilds.model';
import { set } from 'lodash';
import CustomisedErrorCard from '../../../components/card/errorCard';
import AdditionalFieldSkeleton from './additionalFieldSkeleton';
import { ApiResultModel } from '../../../models/common.model';
import { getFormRejectReasons } from '../../../services/registration.service';

export default function AdditionalFields({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const [desc, setDesc] = useState<string>();
    const [inputsCheck, setInputsCheck] = useState<any[]>();
    const [rejectReasons, setRejectReasons] = useState<string[]>();
    const [rejectKey, setRejectKey] = useState<string[]>();
    const { setHeader } = useAppBar();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();


    const { mutateAsync: getFormRejectReasonsMutation } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                let arrayResaon: string[] = [];
                let arrayKey: string[] = [];
                setInputsCheck((prevInputs) => {
                    if (!prevInputs) return prevInputs;
                    const updatedInputsCheck = prevInputs.map((input) => {
                        const matchedReject = data[0]?.additionalFieldsRejectReasons.find((item) => item.key === input.key);
                        if (matchedReject) {
                            arrayKey.push(input.key);
                            arrayResaon.push(...matchedReject.rejectReasons);
                            return { ...input, error: true };
                        }
                        return input;
                    });

                    return updatedInputsCheck;
                });
                setRejectReasons(arrayResaon)
                setRejectKey(arrayKey)
            },
        }
    );
    const { mutate: GetAdditionalFieldsMutation, isLoading } = useMutation(GetAdditionalFields, {
        onSuccess: (data: IAdditionalFieldsRsponse) => {
            if (data) {
                setDesc(data.mainTermsHtml);
                setInputsCheck(data.fields);
                // console.log(data.fields, 'data.fields');

                const request = {} as IGetFormRejectReasonsRequest;
                request.referenceKey = referenceKey!;
                request.form = 'AdditionalFields';
                getFormRejectReasonsMutation(request);
            }
        }
    }
    )

    const { mutate: SetAdditionalFieldsMutation } = useMutation(SetAdditionalFields, {
        onSuccess: (data: ApiResultModel<SetAdditionalFieldsResponse[]>) => {
            if (data.isSuccess) {
                if (data.data.length > 0) {
                    let arrayResaon: string[] = [];
                    let arrayKey: string[] = [];
                    const updatedInputsCheck = inputsCheck?.map((item) => {
                        const matchedData = data.data.find((dataItem) => dataItem.key === item.key);
                        if (matchedData) {
                            arrayResaon.push(...matchedData.rejectReasons);
                            arrayKey.push(matchedData.key);
                            return { ...item, error: true };
                        }
                        return item;
                    });
                    setInputsCheck(updatedInputsCheck);
                    setRejectKey(arrayKey)
                    setRejectReasons(arrayResaon);

                } else {
                    dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch}` }));
                }

            }
        }
    }
    )
    const handleUpdateInputs = (newInputs: IFields[]) => {
        // const filteredInputs = newInputs.map(({ key, value }) => ({ key, value }));
        setInputsCheck(newInputs);
    };
    const handleAdditionalFields = () => {
        SetAdditionalFieldsMutation({ referenceKey: referenceKey!, values: inputsCheck! });
    }
    useEffect(() => {

        setHeader('اطلاعات تکمیلی', 'additional');
        GetAdditionalFieldsMutation({ referenceKey: referenceKey! });


        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));

    }, []);
    if (isLoading) {
        return (
            <AdditionalFieldSkeleton />)
    }
    return (
        <div className="container-height-drawer">
            <div className="content-container">
                <div className='drawer-content'>
                    <div className="!mt-4" dangerouslySetInnerHTML={{ __html: desc || '' }}>
                        {/* {inputs?.mainTermsHtml} */}
                    </div>
                    {rejectReasons && rejectReasons.length > 0 ? <div className="mt-3 ">
                        <CustomisedErrorCard titleList={rejectReasons!} />
                    </div> : null}
                    <DynamicActionForm inputs={inputsCheck} updateInput={handleUpdateInputs} rejectKey={rejectKey} />
                </div>
                <div className="py-5">
                    <CustomisedButton
                        title={'ثبت و ادامه'}
                        disable={false}
                        onClick={handleAdditionalFields}
                        type="submit"
                    />
                </div>
            </div>
        </div>
    )
}
